export const skuTableCols = (_this)=>{
    let openSource = _this.openSource
    let isShowPreviewPrice = true;
    if(['taskCenter','previewPublish'].includes(openSource)){
        isShowPreviewPrice = false
    }
    let tableCols = [
        { prop: 'price', attrs: { label: '价格' }, input: { type: 'number', validator: ()=>{} }, previewPrice: isShowPreviewPrice },
        { prop: 'skuStock', attrs: { label: '库存' },input:{type: 'number',onlyTable: true} },
        { prop: 'weight', attrs: { label: '包含装重量(g)',width:110 }, 
            input: { 
                type: 'number', 
            }, 
            // disabledFn: (row) => row.stockType == 1 
        },
        { prop: 'size', attrs: { label: '包含装尺寸(cm)',width:200 }, 
            input: { 
                type: 'size', 
                x:{
                    prop:'length',
                    placeholder:'长(最长边)',
                },
                y:{
                    prop:'width',
                    placeholder:'宽(次长边)',
                },
                z:{
                    prop:'height',
                    placeholder:'高(最短边)',
                }
            }, 
            disabledFn: (row) => row.stockType == 1 
        },
        { prop: 'skcSupplierCode', attrs: { label: '供方货号',width:150 }, input: { type: 'text', validator: ()=>{} } },
        { prop: 'supplierSku', attrs: { label: '商家sku(商家编码)',noRequired:true,width:150 }, input: { type: 'text', onlyTable: true }},
        { prop: 'stopPurchase', attrs: { label: '采购状态',width:100 }, input: { type: 'select', onlyTable: true },items:[{label:'正常供应',value:1},{label:'暂时缺货',value:2}] },
    ];
    return tableCols
}

// 图片类型枚举
export const ImageType = {
    'MAIN':1,
    'DETAIL':2,
    'SQUARE':5,
    'PIECE':6,
    1:1,
    2:2,
    5:5,
    6:6
}